import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Icon from '../../../../../components/Icons'
import { getAssetLink } from '../../../../../helpers/get-asset-link'

const ProviderItem = ({
  onEdit = () => {},
  onDelete = () => {},
  provider,
  isEditable = false,
  dragHandleProps,
  ...props
}) => {
  const { t } = useTranslation(['checklists-create-task'])
  return (
    <div className="provider-item" {...props}>
      {isEditable && (
        <div className="draggbale-head" {...dragHandleProps}>
          <Icon icon="gripDots" />
        </div>
      )}
      <div className="provider-item-container">
        <div className="provider-name">
          <span>{provider.name}</span>
          {isEditable && (
            <div>
              <button className="button" onClick={onEdit}>
                <Icon icon="pencil" />
              </button>
              <button className="button delete-provider" onClick={onDelete}>
                <Icon icon="delete" />
              </button>
            </div>
          )}
        </div>
        {provider.logo && (
          <img
            src={getAssetLink({ path: 'chitown-images/checklist', file: provider.logo })}
            alt={t('checklists-create-task:providerItem.logoAlt')}
          />
        )}
        <div className="divider" />
        {provider.phoneNumber && (
          <span>
            <Icon
              icon="phone"
              viewBox="6 -1 10 22"
              svgProps={{ stroke: '#282828', strokeLinecap: 'round', strokeLinejoin: 'round' }}
              fill="none"
            />
            {provider.phoneNumber}
          </span>
        )}
        {provider.siteUrl && (
          <span>
            <Icon icon="link" fill="#282828" />
            {provider.siteUrl}
          </span>
        )}
      </div>
    </div>
  )
}

ProviderItem.propTypes = {
  provider: PropTypes.shape({
    name: PropTypes.string,
    logo: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    phoneNumber: PropTypes.string,
    siteUrl: PropTypes.string,
  }),
  isEditable: PropTypes.bool,
  dragHandleProps: PropTypes.object,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
}

export default ProviderItem
